import React, { useState, useEffect, useRef } from 'react'

import { MediaAudioLUFSAnalyser } from './lufs_analyser'

import './AudioLevelIndicator.scss'

interface AudioLevelIndicatorProps {
  mediaStream?: MediaStream
  audioTrack?: MediaStreamTrack
  enabled?: boolean
}

const AudioLevelIndicator = ({
  mediaStream,
  audioTrack,
  enabled = true,
}: AudioLevelIndicatorProps) => {
  const [audioLevel, setAudioLevel] = useState(0)
  const lufsAnalyser = useRef<MediaAudioLUFSAnalyser>(
    new MediaAudioLUFSAnalyser()
  )

  useEffect(() => {
    if (mediaStream) {
      lufsAnalyser.current.setStream(mediaStream)
      lufsAnalyser.current.updateEvery(setAudioLevel, 50)
    } else if (audioTrack) {
      lufsAnalyser.current.setStream(new MediaStream([audioTrack]))
      lufsAnalyser.current.updateEvery(setAudioLevel, 50)
    } else {
      setAudioLevel(0)
      return undefined
    }
    return lufsAnalyser.current.cleanAll
  }, [audioTrack, mediaStream])

  useEffect(() => {
    if (enabled) {
      lufsAnalyser.current.unpause()
    } else {
      lufsAnalyser.current.pause()
      setAudioLevel(0)
    }
  }, [enabled])

  return (
    <meter
      className="audio-level-indicator"
      min={0}
      max={1}
      low={0.01}
      high={0.66}
      optimum={audioLevel > 0.95 ? 0 : 0.5}
      value={audioLevel}
    />
  )
}

export { AudioLevelIndicator }
